import React from "react";
import { useContent } from "../../lib/content";

export const BrandsBand = () => {
  const { brandsBand: b } = useContent();
  return (
  <section data-testid="brands-band" className="bg-[#06142e] text-white border-t border-white/10">
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-10 md:py-12">
      <h2 className="text-2xl md:text-3xl font-extrabold" data-testid="brands-band-heading">{b.heading}</h2>
      <p className="mt-3 max-w-3xl text-slate-300 leading-relaxed" data-testid="brands-band-text">
        {b.text}{" "}
        <a href="sms:+12525450011" data-testid="brands-band-phone" className="font-bold text-[#3b9dff] hover:underline whitespace-nowrap">(252) 545-0011</a>
      </p>
    </div>
  </section>
  );
};
